<div>
  <div class="rs-modal-close">
    <button class="rs-link-action rs-link-action-close close-reveal-modal" (click)="close()">
      <span class="rs-action-link-icon" title="{{ 'common.overlayer.close.caption' | translate }}"
        ><span class="show-for-sr">{{ 'common.overlayer.close.caption' | translate }}</span></span
      >
    </button>
  </div>
  <h2 class="rs-modal-heading-title" id="modal_label">
    {{ 'mpay.delete.mandate.title' | translate }}
  </h2>
  <div class="rs-modal-content">
    <p>{{ 'mpay.delete.mandate.description' | translate }}</p>
  </div>
  <div class="rs-modal-footer">
    <div
      class="rs-flex-row rs-flex-middle-medium rs-justify-right-medium rs-flex-dir-col-small-only"
    >
      <div class="rs-flex-columns rs-flex-shrink rs-order-m2">
        <button class="rs-btn rs-btn-nl-so" (click)="confirm()" [disabled]="buttonsDisabled">
          {{ 'mpay.delete.mandate.confirm' | translate }}
        </button>
      </div>
      <div class="rs-flex-columns rs-order-m1">
        <a href="javascript:void(0)" class="rs-btn rs-btn-second rs-btn-nl-m" (click)="close()">
          {{ 'mpay.delete.mandate.cancel' | translate }}
        </a>
      </div>
    </div>
  </div>
</div>
